interface Props {
  label?: string;
  size?: "sm" | "md";
  tone?: "primary" | "light";
  className?: string;
}

/** Petite pulsation « Grafton réfléchit » : un cœur qui respire et deux anneaux qui s'étendent. */
export default function ThinkingPulse({ label = "Grafton réfléchit…", size = "md", tone = "primary", className = "" }: Props) {
  const c = tone === "light" ? ["bg-primary-foreground/50", "bg-primary-foreground/40", "bg-primary-foreground"] : ["bg-primary/50", "bg-primary/40", "bg-primary"];
  const d = size === "sm" ? "h-3 w-3" : "h-4 w-4";
  const box = size === "sm" ? "h-5 w-5" : "h-7 w-7";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} role="status" aria-live="polite" data-testid="thinking-pulse">
      <span className={`relative inline-flex items-center justify-center ${box}`}>
        <span className={`grafton-pulse-ring absolute ${d} rounded-full ${c[0]}`} style={{ animation: "grafton-ring 1.8s ease-out infinite" }} />
        <span className={`grafton-pulse-ring absolute ${d} rounded-full ${c[1]}`} style={{ animation: "grafton-ring 1.8s ease-out 0.9s infinite" }} />
        <span className={`grafton-pulse-core relative ${d} rounded-full ${c[2]}`} style={{ animation: "grafton-breathe 1.6s ease-in-out infinite" }} />
      </span>
      {label && <span className="text-xs text-muted-foreground">{label}</span>}
    </span>
  );
}
